import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  active: boolean;
} & React.HTMLProps<HTMLDivElement>;

/* eslint-disable @typescript-eslint/no-unused-vars */
const BoxComponent: FC<Props> = ({ active, ...props }) => {
  return <div {...props}></div>;
};

const Box = styled(BoxComponent)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 2.4rem;
  background-color: ${({ active }) =>
    active ? 'var(--primary-50)' : 'transparent'};
  color: ${({ active }) =>
    active ? 'var(--primary-700)}' : 'var(--gray-700)'};
  stroke: ${({ active }) =>
    active ? 'var(--primary-500)' : 'var(--gray-500)'};
  margin-bottom: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
  position: relative;

  svg {
    position: absolute;
    left: 0.5rem;
    width: 1rem;
  }

  &:hover {
    background-color: ${({ active }) =>
      active ? 'var(--primary-50)' : 'var(--gray-100)'};
  }

  outline-offset: -1px;
`;

export default Box;
